module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!../node_modules/xo-page-components/src/value-props/template.html
// module id = ../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html
// module chunks = 0